import React from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"

import Layout from "../../components/Layout"
import StaticAlternates from "../../components/StaticAlternates"
import { HTML_SITEMAP_SECTIONS } from "../../data/footerNavigation"

const HtmlSitemapFrPage = () => {
  const sections = HTML_SITEMAP_SECTIONS.fr || []

  return (
    <Layout locale="fr">
      <StaticAlternates
        locale="fr"
        canonicalPath="/fr/plan-du-site/"
        enPath="/en/sitemap/"
        frPath="/fr/plan-du-site/"
      />
      <Helmet>
        <html lang="fr" />
        <title>Plan du site | GADAIT International</title>
        <meta
          name="description"
          content="Plan du site HTML de GADAIT International. Acces rapide aux pages principales, destinations, programmes neufs et parcours de contact."
        />
      </Helmet>
      <section className="container py-16 mx-auto">
        <h1 className="text-3xl font-semibold text-gray-900">Plan du site</h1>
        <p className="mt-3 text-base text-gray-600">
          Navigation rapide vers les pages cles du site.
        </p>

        <div className="grid grid-cols-1 gap-10 mt-10 md:grid-cols-2">
          {sections.map((section, index) => (
            <div key={`fr-sitemap-${index}`}>
              <h2 className="text-sm font-semibold tracking-wider text-gray-400 uppercase">
                {section.title}
              </h2>
              <ul className="mt-4 space-y-3">
                {section.links.map((item, key) => (
                  <li key={key}>
                    <Link
                      to={item.to}
                      className="text-base text-gray-700 hover:text-gray-900"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  )
}

export default HtmlSitemapFrPage
